import {
  Box,
  Chip,
  IconButton,
  Typography,
  Switch,
  Container,
  Tooltip,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import SyncIcon from "@mui/icons-material/Sync";
import AppGrid from "../app/AppGrid";
import {
  useGetAllFeatureFlagsMutation,
  useToggleFeatureFlagMutation,
} from "../../redux/reducer/features/Dealer/DealerSettingsSlice";

const FeatureFlags: React.FunctionComponent = () => {
  const [featureFlags, setFeatureFlags] = useState<any[]>([]);

  const [getAllFeatureFlags, getAllFeatureFlagsResult] =
    useGetAllFeatureFlagsMutation();
  const [toggleFeatureFlag, toggleFeatureFlagResult] =
    useToggleFeatureFlagMutation();

  const fetchAllFlags = async () => {
    try {
      const response = await getAllFeatureFlags().unwrap();

      if (response.status === 200) {
        setFeatureFlags(response.entityList || []);
      } else {
        setFeatureFlags([]);
      }
    } catch (err: any) {
      setFeatureFlags([]);
    }
  };

  const handleToggle = async (
    dmsSetupId: string,
    flagName: string,
    currentValue: boolean,
  ) => {
    try {
      await toggleFeatureFlag({
        dmsSetupId,
        flagName,
        isEnabled: !currentValue,
      }).unwrap();

      fetchAllFlags();
    } catch (err: any) {
      fetchAllFlags();
    }
  };

  useEffect(() => {
    fetchAllFlags();
  }, []);

  const columns: GridColDef[] = [
    {
      field: "dmsDealerId",
      headerName: "DMS Dealer ID",
      width: 150,
      editable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params?.row?.dmsDealerId || "N/A",
    },
    {
      field: "siteName",
      headerName: "Site Name",
      width: 200,
      editable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params?.row?.siteName || "N/A",
    },
    {
      field: "siteDomain",
      headerName: "Site Domain",
      width: 300,
      editable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params?.row?.siteDomain || "N/A",
    },
    {
      field: "enablePricePromotion",
      headerName: "Price Promotion",
      width: 200,
      type: "actions",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title="Toggle Price Promotion">
            <Switch
              checked={params?.row?.enablePricePromotion}
              onChange={() =>
                handleToggle(
                  params?.row?.dmsSetupId,
                  "EnablePricePromotion",
                  params?.row?.enablePricePromotion,
                )
              }
              color="primary"
              size="small"
              disabled={toggleFeatureFlagResult.isLoading}
            />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Container maxWidth={false}>
      <Box display="flex" alignItems="center">
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Feature Flags
        </Typography>
        <IconButton onClick={() => fetchAllFlags()}>
          <SyncIcon />
        </IconButton>
      </Box>

      <AppGrid
        data={featureFlags}
        isLoading={
          toggleFeatureFlagResult.isLoading ||
          getAllFeatureFlagsResult.isLoading
        }
        columns={columns}
        checkBox={true}
        getRowId={(row: any) => row.dmsSetupId}
        height={"80vh"}
      ></AppGrid>
    </Container>
  );
};

export default FeatureFlags;
